export default "__VITE_ASSET__RqiAf_n$__"